module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi_ekimae/appeal_01-a7f6eba5e0bfa58ff4608deee6f405eb.jpg";